import { motion } from "framer-motion";
import { ArrowUpRight, Code2, Layers3 } from "lucide-react";
import { projects } from "../data";

export default function Projects() {
  return (
    <section id="projects" className="section-shell">
      <motion.div
        initial={{ opacity: 0, y: 28 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.25 }}
        transition={{ duration: 0.6 }}
        className="mx-auto max-w-3xl text-center"
      >
        <p className="text-sm font-bold uppercase tracking-[0.35em] text-cyan-200">Миний хийсэн төслүүд</p>
        <h2 className="mt-4 font-display text-3xl font-black text-white sm:text-5xl">Миний хийсэн төслүүд</h2>
      </motion.div>

      <div className="mt-12 grid gap-6 lg:grid-cols-2">
        {projects.map((project, index) => {
          const projectLinks = project.links ?? [];

          return (
            <motion.article
              key={project.title}
              initial={{ opacity: 0, y: 34 }}
              whileInView={{ opacity: 1, y: 0 }}
              whileHover={{ y: -8, scale: 1.015 }}
              viewport={{ once: true, amount: 0.18 }}
              transition={{ duration: 0.55, delay: index * 0.06 }}
              className="group relative overflow-hidden rounded-2xl p-px"
            >
              <div className={`absolute inset-0 bg-gradient-to-br ${project.accent} opacity-45 transition duration-300 group-hover:opacity-90`} />
              <div className="glass-card relative h-full overflow-hidden p-4 sm:p-6">
                <div className="mb-6 overflow-hidden rounded-2xl border border-white/10 bg-slate-950/50 shadow-2xl shadow-black/30">
                  {project.image ? (
                    <img
                      src={project.image}
                      alt={project.imageAlt ?? `${project.title} preview`}
                      loading="lazy"
                      className="aspect-[16/9] w-full object-cover transition duration-500 group-hover:scale-105"
                    />
                  ) : (
                    <div className={`grid aspect-[16/9] place-items-center bg-gradient-to-br ${project.accent} p-6`}>
                      <div className="rounded-2xl border border-white/25 bg-slate-950/35 p-5 text-white backdrop-blur-xl">
                        <Layers3 size={38} />
                      </div>
                    </div>
                  )}
                </div>

                <div className="mb-4 flex items-start justify-between gap-3 sm:gap-4">
                  <div className="min-w-0">
                    <p className="text-sm font-black text-cyan-200">0{index + 1}</p>
                    <h3 className="mt-2 text-xl font-black leading-tight text-white sm:text-2xl">{project.title}</h3>
                  </div>
                  <ArrowUpRight className="mt-2 shrink-0 text-slate-400 transition group-hover:text-cyan-200" />
                </div>

                <p className="text-sm leading-7 text-slate-300 lg:min-h-24">{project.desc}</p>

                <div className="mt-5 flex flex-wrap gap-2">
                  {project.tags.map((tag) => (
                    <span key={tag} className="skill-badge">
                      {tag}
                    </span>
                  ))}
                </div>

                {projectLinks.length > 0 && (
                  <div className="mt-6 grid gap-3 sm:flex sm:flex-wrap">
                    {projectLinks.map((link) => (
                      <a key={link.href} href={link.href} target="_blank" rel="noreferrer" className="btn-soft w-full px-4 py-2.5 sm:w-auto">
                        <Code2 size={17} /> {link.label}
                      </a>
                    ))}
                  </div>
                )}
              </div>
            </motion.article>
          );
        })}
      </div>
    </section>
  );
}
